// src/data/updatesData.js

// 1. Importe os ícones que você vai usar
import React from 'react';
// Ícones novos: FiClock (Loading), FiPieChart (Gráficos), FiPrinter (Relatórios)
import { FiClock, FiPieChart, FiPrinter } from "react-icons/fi"; 

// 2. Exporte o array com os dados das novas atualizações do sistema!
export const updatesData = [
    { 
        icon: <FiClock />, 
        title: "Carregamento Visual nas Páginas", 
        description: "Implementado efeito de carregamento visual em todas as páginas para melhor feedback ao usuário durante a busca de dados." 
    },
    { 
        icon: <FiPieChart />, 
        title: "Gráficos nas Despesas da Frota", 
        description: "Adicionados gráficos interativos de evolução mensal e distribuição por categoria na página de Despesas Gerais da Frota." 
    },
    { 
        icon: <FiPrinter />, 
        title: "Melhorias nos Relatórios", 
        description: "Aprimoramentos gerais na geração e visualização de relatórios em PDF, incluindo mais opções de personalização e dados visuais." 
    },
    // Adicione mais atualizações futuras aqui...
];